import { ApolloProvider } from "@apollo/client";
import { ExperimentProvider } from "@ottatech/analytics";
import { theme } from "@ottatech/shared-components";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { UnleashClient } from "@unleash/proxy-client-react";
import { MotionConfig } from "framer-motion";
import { HelmetProvider } from "react-helmet-async";

import { apolloClient } from "./apollo";
import { MaintenanceProvider } from "./maintenance";
import { IAPRefresher } from "./iap";

const config = {
  url: process.env.REACT_APP_UNLEASH_URL,
  clientKey: process.env.REACT_APP_UNLEASH_PROXY_CLIENT_KEY,
  appName: "search",
  environment: process.env.REACT_APP_ENV,
};

const client = new UnleashClient(config);

export function Providers({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <HelmetProvider>
      <ApolloProvider client={apolloClient}>
        <MaintenanceProvider>
          <IAPRefresher>
            <ExperimentProvider client={client}>
              <ThemeProvider theme={theme}>
                <MotionConfig reducedMotion="user">
                  <Router>{children}</Router>
                </MotionConfig>
              </ThemeProvider>
            </ExperimentProvider>
          </IAPRefresher>
        </MaintenanceProvider>
      </ApolloProvider>
    </HelmetProvider>
  );
}
